// extracted by mini-css-extract-plugin
module.exports = {"featured":"details_featured__3sPh7","popuptext":"details_popuptext__3Pj5q","show":"details_show__z9eu1","fadeIn":"details_fadeIn__1SlDy"};